import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'pages',
        loadChildren: './pages/pages.module#PagesModule',
      },
      {
        path: 'dashboard',
        loadChildren: './dashboard/dashboard.module#DashboardModule',
      },
      {
        path: 'cards',
        loadChildren: './cards/cards.module#CardsModule',
      },
      {
        path: 'pinmailer',
        loadChildren: './pinmailer/pinmailer.module#PinmailerModule',
      },
      {
        path: 'admin',
        loadChildren: './admin/admin.module#AdminModule',
      },
      {
        path: 'stock',
        loadChildren: './stock/stock.module#StockModule',
      },
      {
        path: 'reports',
        loadChildren: './reports/reports.module#ReportsModule',
      },
      {
        path: 'epin',
        loadChildren: './epin/epin.module#EpinModule',
      },
      {
        path: '',
        redirectTo: 'pages/login',
        pathMatch: 'full',
      },
    ]
  },
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app.routing.ts